import { esc } from "../ui/format.js";
import { uiCard, uiGet, uiHeader, uiKpis, uiMoney } from "../ui/kit.js";
import { emAct, emLetters, emLog, emWireLetters } from "./empire.js";
import { nmFace } from "./nemesis.js";

/**
 * Brand Ambassadors (backend/sponsors.py): famous faces for your brand.
 * The roster is a swipeable carousel (no search box). Each card shows the
 * fee, the brand jump on signing, the monthly growth, how well they fit
 * your industry and their scandal risk.
 */

function abCard(s, full) {
  const signed = s.status === "signed";
  return `<article class="ab-card${signed ? " on" : ""}${s.fit ? " fit" : ""}">
    <div class="ab-face">${nmFace(s.face_seed, 92)}<span class="ab-field">${s.icon}</span></div>
    <b>${esc(s.name)}</b>
    <span class="ab-role">${esc(s.field_label)} · fame ${Math.round(s.fame)}</span>
    <div class="ab-tags">${s.fit ? `<i class="pos">Fits your industry ×1.3</i>` : `<i>Weak fit ×0.8</i>`}<i class="risk-${s.risk_label.toLowerCase()}">${s.risk_label} scandal risk</i></div>
    <ul><li>Brand <b>+${s.brand_on_signing}</b> on signing</li><li>Growth <b>+${s.growth_pts} pts</b> a month</li>
      <li>${uiMoney(s.monthly_fee, { compact: true })} a month${signed ? "" : ` · ${uiMoney(s.signing_fee, { compact: true })} to sign`}</li></ul>
    ${signed ? `<em>Signed · ${s.months_left} months left</em><button type="button" data-ab-release="${s.id}">End early (2 months' fee)</button>`
      : s.status === "dropped" ? `<em>Dropped after a scandal</em>`
      : `<button type="button" class="primary" data-ab-sign="${s.id}" ${full ? "disabled" : ""}>${full ? "Two signed already" : "Sign for 12 months"}</button>`}
  </article>`;
}

async function renderAmbassadors(main, snap, { embedded = false } = {}) {
  const a = await uiGet("/ambassadors");
  const full = a.signed.length >= a.max_active;
  const intro = "Put a famous face on your brand. A big boost when you sign, faster sales every month. If they're caught in a scandal, your brand takes the hit too.";
  main.innerHTML = `
    <div class="${embedded ? "em" : "sx em"}">
      ${embedded ? `<h3 class="mk-h">⭐ Brand ambassadors</h3><p class="mk-sub">${intro}</p>` : uiHeader(`Brand Ambassadors — Month ${a.month}`, intro)}
      ${uiKpis([
        { label: "Signed", value: `${a.signed.length} of ${a.max_active}` },
        { label: "Growth from stars", value: `+${a.growth_pts} pts`, sub: "a month" },
        { label: "Fees", value: uiMoney(a.monthly_fees, { compact: true }), sub: "a month (Sales & Marketing)" },
      ])}
      ${a.open.length ? uiCard("Scandal!", emLetters(a.open)) : ""}
      ${a.signed.length ? uiCard("Your faces", `<div class="ab-row">${a.signed.map((s) => abCard(s, full)).join("")}</div>`) : ""}
      ${uiCard("The roster", `<div class="ab-carousel" tabindex="0" aria-label="Stars you can sign">
          <button type="button" class="ab-nav prev" aria-label="Previous">‹</button>
          <div class="ab-track">${a.stars.filter((s) => s.status !== "signed").map((s) => abCard(s, full)).join("")}</div>
          <button type="button" class="ab-nav next" aria-label="Next">›</button></div>`, { sub: a.rules })}
      ${uiCard("What happened", emLog(a.history, { emptyText: "No scandals yet. Fingers crossed." }))}
    </div>`;
  emWireLetters(main);
  const track = main.querySelector(".ab-track");
  main.querySelector(".ab-nav.prev").addEventListener("click", () => track.scrollBy({ left: -track.clientWidth * 0.8, behavior: "smooth" }));
  main.querySelector(".ab-nav.next").addEventListener("click", () => track.scrollBy({ left: track.clientWidth * 0.8, behavior: "smooth" }));
  main.querySelectorAll("[data-ab-sign]").forEach((b) => b.addEventListener("click", () => {
    const s = a.stars.find((x) => x.id === +b.dataset.abSign);
    if (confirm(`Sign ${s.name} for 12 months? ${uiMoney(s.signing_fee)} now, then ${uiMoney(s.monthly_fee)} a month.`)) emAct("sponsor_sign", { id: s.id });
  }));
  main.querySelectorAll("[data-ab-release]").forEach((b) => b.addEventListener("click", () => emAct("sponsor_release", { id: +b.dataset.abRelease })));
}

window.renderAmbassadors = renderAmbassadors;

export { renderAmbassadors };
